"use client";

import { useEffect, useRef } from "react";
import { initPostHog, posthogOptIn, posthogOptOut } from "@/lib/posthog";
import { CONSENT_EVENT } from "@/components/Analytics";

/**
 * PostHog yaşam döngüsü — Analytics.tsx ile aynı KVKK kapısı.
 * Analitik onayı varsa init + kayıt açılır; geri çekilince kayıt durur.
 * Pazarlama onayı PostHog'u etkilemez (ürün analitiği, reklam değil).
 */
export function PostHogProvider() {
  // storage/consent olay fırtınasında aynı kararı tekrar uygulamayı keser —
  // opt_in/out + startSessionRecording yalnızca yön DEĞİŞİNCE koşar.
  const lastApplied = useRef<"in" | "out" | null>(null);
  useEffect(() => {
    const apply = () => {
      let analytics = false;
      try {
        const raw = localStorage.getItem("onomac-cookie-consent");
        if (raw === "accepted") analytics = true;
        else {
          const parsed = raw ? JSON.parse(raw) : null;
          analytics =
            parsed?.status === "accepted" ||
            (parsed?.status === "custom" && !!parsed.analytics);
        }
      } catch {
        analytics = false;
      }
      const want = analytics ? "in" : "out";
      if (lastApplied.current === want) return;
      lastApplied.current = want;
      if (analytics) {
        if (initPostHog()) posthogOptIn();
        else lastApplied.current = null;
      } else {
        posthogOptOut();
      }
    };
    apply();
    window.addEventListener(CONSENT_EVENT, apply);
    window.addEventListener("storage", apply);
    return () => {
      window.removeEventListener(CONSENT_EVENT, apply);
      window.removeEventListener("storage", apply);
    };
  }, []);

  return null;
}
